import { render } from "./GroupUpdateForm.vue?vue&type=template&id=69cec819"
import script from "./GroupUpdateForm.vue?vue&type=script&lang=js"
export * from "./GroupUpdateForm.vue?vue&type=script&lang=js"
script.render = render

export default script